<template>
  <ul class="social">
    <li class="social-facebook"><a href="https://www.facebook.com/sharer/sharer.php" target="_blank" class="fa fa-facebook social-icons"></a></li>
    <li class="social-google-plus"><a :href="`https://plus.google.com/share?url=${pageUrl}`" target="_blank" class="fa fa-google-plus social-icons"></a></li>
    <li class="social-twitter"><a :href="`https://twitter.com/home?status=${pageUrl}`" target="_blank" class="fa fa-twitter social-icons"></a></li>
    <li class="social-rss"><a href="http://rss.itrtv.com" target="_blank" class="fa fa-rss social-icons"></a></li>
  </ul>
</template>

<script>
  export default {
    name: 'Social',
    mounted() {
      this.pageUrl = window.location.href;
    },
    data() {
      return {
        pageUrl: '',
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/elements/Social.vue